import { Button, Center, Stack, Text, ThemeIcon, Title } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
import type { ReactNode } from "react";

interface ErrorStateProps {
  message?: ReactNode;
  title?: string;
  onRetry?: () => void;
  retryLabel?: string;
}

export function ErrorState({
  message = "Something went wrong. Please try again.",
  title = "Unable to load",
  onRetry,
  retryLabel = "Retry",
}: ErrorStateProps) {
  return (
    <Center py="var(--axio-unit-56)" px="md">
      <Stack align="center" gap="md" maw="var(--axio-unit-420)">
        <ThemeIcon size="var(--axio-unit-48)" variant="light" color="red">
          <IconAlertCircle size="var(--axio-unit-24)" stroke="var(--axio-stroke-width-subtle)" />
        </ThemeIcon>
        <Title order={4} ta="center">
          {title}
        </Title>
        <Text c="dimmed" size="sm" ta="center" lh="var(--axio-line-height-loose)">
          {message}
        </Text>
        {onRetry && (
          <Button variant="filled" color="violet" onClick={onRetry}>
            {retryLabel}
          </Button>
        )}
      </Stack>
    </Center>
  );
}
